import {
  JOB_HUNTING_STATUS_UPDATE,
  NEW_GRADES_PROFILE_UPDATE,
  REGISTS_AC_EMAIL,
  REGISTS_CONFIRM,
  REGISTS_FINISH,
  RULE_CONFIRM,
} from '../../../config/constants/routes';

type Args = {
  isAuthenticated: boolean;
  isAppWebView: boolean;
  pathname: string;
};

// 会員登録直後のフローでは登録の完了を優先させるため出さない。
const EXCLUDED_PATHS = [REGISTS_CONFIRM, REGISTS_FINISH, REGISTS_AC_EMAIL];

const EXCLUDED_PATH_PREFIXES = [
  // エントリー手続きの途中で別の募集を勧めると邪魔になるため出さない
  '/recruitment_step_user_applies',
  '/recruitment_step_upload_files',
  '/recruitments/entries',
  '/recruitments/seminars',
  // 募集や企業を見ている最中にも出さない（一覧・詳細の両方が前方一致で入る）
  '/recruiting_info',
  '/company',
  // 対応を終えるまで他ページに遷移できない強制フローなので、割り込ませない
  RULE_CONFIRM,
  NEW_GRADES_PROFILE_UPDATE,
  JOB_HUNTING_STATUS_UPDATE,
];

/**
 * ポップアップを出してよい状況かを判定する。
 * 会員登録完了ページを除くのは、そこには既におすすめ募集のセクションがあるため。
 * 大学メール認証ページを除くのは、認証を促す導線を妨げないため。
 * アプリ内WebViewを除くのは、アプリ側のポップアップと二重に出さないため。
 */
export const canRequestPostRegisterEntryPrompt = ({
  isAuthenticated,
  isAppWebView,
  pathname,
}: Args): boolean => {
  if (!isAuthenticated || isAppWebView || EXCLUDED_PATHS.includes(pathname)) {
    return false;
  }
  return !EXCLUDED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};
